class Header {

  static init () {
    let header = document.querySelectorAll('#overflow-wrapper > header'),
        headerStages = document.querySelectorAll('#overflow-wrapper > header .image-wrapper, #overflow-wrapper > header .stage-wrapper');

    if(headerStages.length) {

      if(header.length) {
        header[0].classList.remove('has-border');
      }
    }
  }

  static setStickyHeaderView () {
    let header = document.querySelectorAll('#overflow-wrapper > header');

    if(header.length) {

      if(window.pageYOffset > header[0].clientHeight) {
        header[0].classList.add('scrolled');
      } else {
        header[0].classList.remove('scrolled');
      }
    }
  }
}

export {
  Header
};